module.exports = __webpack_public_path__ + "img/top25.2d207460.png";